<template>
  <header class="header color-container-branco navbar navbar-expand-lg navbar-sticky navbar-stuck position-absolute navbar-sticky z-index-header">
    <div class="container px-3 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <img class="me-2" src="../../assets/images/LOGO_NEWTEC_CLOUD_ICONE_2.png" width="40" alt="Layer">
        <!-- <img class="me-2" src="../../assets/images/LOGO_NEWTEC_CLOUD_ICONE.png" width="40" alt="Layer"> -->
        <h4><strong>Newtec Cloud</strong></h4>
      </div>
      <i class="ph ph-list fs-30 menu-toggle" @click="toggleMenu"></i>

      <ul :class="['style-list', 'd-sm-flex', 'd-lg-flex', 'd-xl-flex', 'd-xxl-flex', { 'active': isMenuActive }]" id="mobileMenu">
        <li class="pointer d-flex align-items-center"><a class="style-link" href="#SectionQuemSomos">Quem somos</a></li>
        <li class="pointer d-flex align-items-center"><a class="style-link" href="#SectionBeneficios">Benefícios</a></li>
        <li class="pointer d-flex align-items-center"><a class="style-link" href="#SectionSistema">Sistema</a></li>
        <!-- <li class="pointer d-flex align-items-center"><a class="style-link" href="#SectionPreco">Preço</a></li> -->
        <li class="pointer d-flex align-items-center"><a class="option-login d-flex" href="/login"><i class="flaticon-user d-flex align-items-center me-2"></i> Entrar</a></li>
      </ul>
    </div>
  </header>
  
  <div>
    <section class="color-container-branco mt-50 position-relative overflow-hidden py-4">
      <div class="container pt-lg-3">
        <div class="row flex-lg-nowrap">
          <div class="col-lg-6 col-xl-5 text-center text-lg-start pt-5 mt-xl-4">
            <h1 class="display-4 pt-5 pb-2 pb-lg-3 mt-sm-2 mt-lg-5 title-home-page">Centralize suas gravações na nuvem</h1>
            
            <p class="fs-18 mb-4 mb-lg-5">Somos a melhor empresa para armazenar e cuidar das suas gravações tudo por um preço acessível.</p>

            <a href="/register" class="btn btn-primary btn-lg mt-40"> 
              Comece agora
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx fs-xl ms-2" width="1em" height="1em" viewBox="0 0 24 24">
                <path fill="currentColor" d="m11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707l-1.414 1.414L15.586 11H6v2h9.586z"></path>
              </svg>
            </a>

            <div class="pt-50 mt-xl-50">
              <h6 class="pt-xl-3 pb-3 pb-lg-4"><strong>Com nosso sistema você pode realizar integração com Smart Sampa</strong></h6>
            </div>

          </div>

          <div class="parallax mt-4 ms-4 me-lg-0 ms-lg-n5 ms-xl-n3 mt-lg-n4">
            <div class="parallax-layer">
              <img src="../../assets/images/home/system333.png" width="1416" alt="Layer">
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  
  <div id="SectionQuemSomos" class="container pb-50 pt-50 mb-50 mt-50">
    <h1 class="border-bottom pb-4">Quem somos</h1>
    <div class="row pt-2 pt-md-3">
      <div class="col-md-6">
        <p class="fs-16 fs-lg pe-lg-4 mb-1 mb-lg-4">Somos uma empresa especializada em armazenamento seguro de gravações de de câmera de segurança em nuvem. Nosso objetivo é proporcionar uma solução confiável para que você possa gerenciar, armazenar e acessar suas gravações de maneira eficiente. Com tecnologia de ponta, garantimos a integridade e segurança dos seus dados, permitindo que você se concentre no que realmente importa: o crescimento do seu negócio.</p>
      </div>
      <div class="col-md-6 mt-50 mt-sm-50 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0">
        <p class="fs-16 fs-lg ps-lg-4 mb-1 mb-lg-4">Na Newtec, entendemos a importância de cada gravação registrada. Por isso, criamos uma plataforma robusta e segura para o armazenamento de gravações de câmera de segurança em nuvem. Nossa missão é facilitar o acesso e a gestão desses dados, garantindo a segurança e a eficiência que sua empresa merece. Conte conosco para proteger o que é essencial para o seu sucesso.</p>
      </div>
    </div>
  </div>

  <div>
    <section id="SectionBeneficios" class="color-container-branco position-relative overflow-hidden py-4">
      <div class="container mt-50">
        <h2 class="h1 text-center pb-4 pb-lg-5 fw-bold mb-40">Porque armazenar gravações em nuvem</h2>
    
        <div class="row mt-50">
          <div class="area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30">
            <div class="bg-secondary rounded-circle-customize p-3 mb-4">
              <i class="color-blue d-flex fs-25 flaticon-volume"></i>
            </div>
            <h3 class="h5 pb-1 mb-2 fw-bold">Escalabilidade</h3>
            <p class="fs-sm">A capacidade de armazenamento pode ser facilmente ajustada conforme o volume de gravações aumenta, sem a necessidade de investimentos em infraestrutura física.</p>
          </div>

          <div class="area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30">
            <div class="bg-secondary rounded-circle-customize p-3 mb-4">
              <i class="color-blue d-flex fs-25 flaticon-draft"></i>
            </div>
            <h3 class="h5 pb-1 mb-2 fw-bold">Redução de Riscos Legais</h3>
            <p class="fs-sm">Armazenar gravações em um ambiente seguro em conformidade com regulamentos ajuda a mitigar riscos legais e proteger a empresa em disputas.</p>
          </div>

          <div class="area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30">
            <div class="bg-secondary rounded-circle-customize p-3 mb-4">
              <i class="color-blue d-flex fs-25 flaticon-lock-1"></i>
            </div>
            <h3 class="h5 pb-1 mb-2 fw-bold">Segurança</h3>
            <p class="fs-sm">Nós oferecemos medidas avançadas de segurança, protegendo os dados contra acesso não autorizado.</p>
          </div>

          <div class="area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30">
            <div class="bg-secondary rounded-circle-customize p-3 mb-4">
              <i class="color-blue d-flex fs-25 flaticon-money"></i>
            </div>
            <h3 class="h5 pb-1 mb-2 fw-bold">Custo-Efetivo</h3>
            <p class="fs-sm">Reduz os custos com hardware e manutenção, além de permitir pagar apenas pelo espaço de armazenamento utilizado.</p>
          </div>

          <div class="area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30">
            <div class="bg-secondary rounded-circle-customize p-3 mb-4">
              <i class="color-blue d-flex fs-25 flaticon-secure-shield"></i>
            </div>
            <h3 class="h5 pb-1 mb-2 fw-bold">Compliance</h3>
            <p class="fs-sm">Facilita a conformidade com regulamentações e leis de proteção de dados, mantendo as gravações seguras e acessíveis conforme necessário.</p>
          </div>

          <div class="area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30">
            <div class="bg-secondary rounded-circle-customize p-3 mb-4">
              <i class="color-blue d-flex fs-25 flaticon-cloud-computing"></i>
            </div>
            <h3 class="h5 pb-1 mb-2 fw-bold">Armazenamento Ilimitado</h3>
            <p class="fs-sm">Oferecemos espaço virtualmente ilimitado para guardar gravações de longo prazo, sem preocupações com a falta de espaço</p>
          </div>

          <div class="area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30">
            <div class="bg-secondary rounded-circle-customize p-3 mb-4">
              <i class="color-blue d-flex fs-25 flaticon-search"></i>
            </div>
            <h3 class="h5 pb-1 mb-2 fw-bold">Facilidade de Busca e Filtragem</h3>
            <p class="fs-sm">Oferecemos ferramentas avançadas de busca e filtragem, permitindo localizar gravações específicas de forma rápida e eficiente.</p>
          </div>

          <div class="area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30">
            <div class="bg-secondary rounded-circle-customize p-3 mb-4">
              <i class="color-blue d-flex fs-25 flaticon-compare"></i>
            </div>
            <h3 class="h5 pb-1 mb-2 fw-bold">Automação de Processos</h3>
            <p class="fs-sm">Você pode configurar nosso sistema, possibilitando limitar o ambiente armazenado</p>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div>
    <section id="SectionSistema" class="color-container-branco position-relative overflow-hidden py-4 pt-50">
      <div class="container pb-2">
        <div class="row align-items-center">
          <div class="rellax col-md-7">
            <img src="../../assets/images/home/system3333.png" class="d-block mx-auto" width="746" alt="Image">
          </div>

          <div class="rellax col-md-5 col-xl-4 offset-xl-1 d-flex d-sm-block flex-column">
            <h2 class="pb-3 pt-2 pt-md-0">Principais funcionalidades</h2>

            <ul class="list-unstyled pb-2">
              <li class="d-flex align-items-center pb-1 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx text-primary fs-xl me-2" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"></path>
                  <path fill="currentColor" d="M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"></path>
                </svg> 
                Integração com Smart Sampa
              </li>

              <li class="d-flex align-items-center pb-1 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx text-primary fs-xl me-2" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"></path>
                  <path fill="currentColor" d="M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"></path>
                </svg> 
                Você pode usar nosso sistema para atender os seus clientes
              </li>

              <li class="d-flex align-items-center pb-1 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx text-primary fs-xl me-2" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"></path>
                  <path fill="currentColor" d="M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"></path>
                </svg> 
                Mosaico de  câmeras para visualizar várias câmeras simultaneamente
              </li>

              <li class="d-flex align-items-center pb-1 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx text-primary fs-xl me-2" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"></path>
                  <path fill="currentColor" d="M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"></path>
                </svg> 
                Reprodução de gravações anteriores ou aovivo
              </li>
              
              <li class="d-flex align-items-center pb-1 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx text-primary fs-xl me-2" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"></path>
                  <path fill="currentColor" d="M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"></path>
                </svg> 
                Mapa de câmeras para visualizar a localização de cada câmera
              </li>
              
              <li class="d-flex align-items-center pb-1 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx text-primary fs-xl me-2" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"></path>
                  <path fill="currentColor" d="M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"></path>
                </svg> 
                Cadastro de instalações/usuários/câmeras para gerenciar os seus clientes
              </li>
              
              <li class="d-flex align-items-center pb-1 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx text-primary fs-xl me-2" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"></path>
                  <path fill="currentColor" d="M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"></path>
                </svg> 
                Fácil instalação e configuração
              </li>

              <li class="d-flex align-items-center pb-1 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx text-primary fs-xl me-2" width="1em" height="1em" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"></path>
                  <path fill="currentColor" d="M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"></path>
                </svg> 
                Você escolhe por quanto tempo quer armazenar as gravações de cada câmera
              </li>

            </ul>
            
            <a href="/register" class="btn btn-primary"> 
              Comece agora
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="bx fs-xl ms-2" width="1em" height="1em" viewBox="0 0 24 24">
                <path fill="currentColor" d="m11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707l-1.414 1.414L15.586 11H6v2h9.586z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>

  <footer class="footer pt-5 pb-4 pb-lg-5">
    <div class="container pt-lg-4">
      <div class="row pb-5">
        <div class="col-md-6 col-lg-4 mt-30">

          <p class="fs-sm pb-lg-3 mb-4"> Nossa missão como empresa é prestar o melhor serviço de armazenamento de gravações em nuvem e proporcionar uma ótima experiência aos nossos clientes e resolver os problemas físicos de limitação de espaço e também estamos comprometidos em aumentar a satisfação de nossos clientes com os nossos serviços prestados. </p>
          <form class="">
            <label for="subscr-email" class="form-label">Assine a nossa newsletter</label>
            <div class="input-group">
              <input id="subscr-email" class="form-control rounded-start ps-5" type="email" required aria-required="true">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="fs-lg text-muted position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5" width="1em" height="1em" viewBox="0 0 24 24">
                <path fill="currentColor" d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223l-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044L20.002 18H4z"></path>
              </svg>
              <div class="invalid-tooltip position-absolute top-100 start-0"> Please provide a valid email address. </div>
              <button class="btn btn-md btn-primary" type="submit">Assinar</button>
            </div>
          </form>
        </div>
        <div class="col-md-5 col-lg-7 col-xl-6 offset-xl-2 offset-md-1 pt-4 pt-md-1 pt-lg-0 mt-30">
          <div class="row" id="footer-links">
            <div class="col-lg-4">
              <div id="useful_links" class="d-block" is-nav="false">
                <ul class="nav flex-column pb-lg-1 mb-lg-3">
                  <li class="nav-item"><a href="#" class="nav-link d-inline-block px-0 pt-1 pb-2">Inicio</a></li>
                  <li class="nav-item"><a href="/login" class="nav-link d-inline-block px-0 pt-1 pb-2">Logar</a></li>
                  <li class="nav-item"><a href="/register" class="nav-link d-inline-block px-0 pt-1 pb-2">Registrar-se</a></li>
                  <li class="nav-item"><a href="/forgot-password" class="nav-link d-inline-block px-0 pt-1 pb-2">Recuperar senha</a></li>
                  <li class="nav-item"><a href="/documentation" class="nav-link d-inline-block px-0 pt-1 pb-2" target="_blank">Documentação</a></li>
                </ul>
                <ul class="nav flex-column mb-2 mb-lg-0">
                  <li class="nav-item"><a href="#" class="nav-link d-inline-block px-0 pt-1 pb-2">Termos e Condições</a></li>
                  <li class="nav-item"><a href="#" class="nav-link d-inline-block px-0 pt-1 pb-2">Política de privacidade</a></li>
                </ul>
              </div>
            </div>
            
            <div class="col-lg-3 col-xl-4 mt-50">
              <div id="social_links" class="d-block" is-nav="false">
                <ul class="nav flex-column mb-2 mb-lg-0">
                  <li class="nav-item">
                    <a href="#" class="nav-link d-inline-block px-0 pt-1 pb-2">
                      Facebook</a>
                    </li>
                    <li class="nav-item">
                      <a href="#" class="nav-link d-inline-block px-0 pt-1 pb-2">
                        LinkedIn
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#" class="nav-link d-inline-block px-0 pt-1 pb-2">
                        Twitter
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#" class="nav-link d-inline-block px-0 pt-1 pb-2">
                        Instagram
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-5 col-xl-4 pt-2 pt-lg-0 text-center">
                <h6 class="mb-2">Contate-nos</h6>
                <a href="mailto:contato@newteccloud.com" class="fw-medium">contato@newteccloud.com</a>
              </div>
            </div>
          </div>
        </div>
        <p class="nav d-block fs-xs text-center text-md-start pb-2 pb-lg-0 mb-0">© 2024 Newteccloud. All rights reserved</p>
        </div>
  </footer>


</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  name: "HomePage",
  data() {
    return {
      quantidade: 0,
      tamanhoMedio: 0,
      valorFinal: "0,00",
      isMenuActive: false
    };
  },
  methods: {
    ...mapActions([
      "setServicePrice",
      "setGbFree",
    ]),
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
    formattedValue(value){
      let numero = parseFloat(value);
      return numero.toFixed(2).replace('.', ',');
    },
    calcularValorFinal() {
      const totalGB = (this.quantidade * this.tamanhoMedio) / 1024;
      const totalCurrentPrice = totalGB * this.getServicePrice;
      const valorFinalSemArredondar = Math.floor(totalCurrentPrice * 100) / 100;
      
      this.valorFinal = new Intl.NumberFormat('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      }).format(valorFinalSemArredondar);
    }
  },
  mounted() {
    this.setServicePrice();
    this.setGbFree();
  },
  computed:{
    ...mapGetters([
      "getServicePrice",
      "getGbFree"
    ])
  },
});

</script>

<style scoped>

.color-container-branco {
  background-color: #fff !important;
}

.color-container-preto {
  background-color: rgba(33, 37, 41, 1) !important;
}

.style-link{
  text-decoration: none;
  font-weight: bold;
  color: #2b2a3f;
  opacity: 0.8;
}

.style-link:hover{
  opacity: 1;
  transition: 0.2s;
}

.z-index-header{
  z-index: 99999;
}

header {
  height: 70px;
  width: 100%;
  box-shadow: 0 .3rem 1.525rem -.375rem rgba(11, 15, 25, .1), 0 .25rem .8125rem -.125rem rgba(11, 15, 25, .06);
}

header h4 {
  margin-bottom: unset;
  cursor: pointer;
}

.style-list{
  list-style: none;
  margin: unset;
}

.style-list li{
  font-size: 14pt;
  margin-right: 40px;
}

.pointer{
  cursor: pointer !important;
}

.option-login{
  background-color: #6560F0;
  color: #fff;
  padding: 5px 15px;
  border-radius: 7px;
  text-decoration: none;
}

.title-home-page{
  margin-top: 80px !important;
  padding-top: 40px !important;
  font-weight: bold;
}

.area-card-home{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rounded-circle-customize{
  border-radius: 100px;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f3f6ff !important;
}

.color-blue{
  color: #6366f1;
}

.custom-buttom-register-now{
  box-shadow: 1px 2px 12px -2px #000;
}

.font-icon{
  font-size: 20pt;
  color: #fff;
}

.area-icon-price{
  background-color: rgba(255, 255, 255, 0.1);
  padding: 10px;
}

.shadow-card-custom{
  box-shadow: 1px 1px 24px -7px #000;
}












/* Estilos básicos */
.header {
    background-color: #fff;
    padding: 10px 0;
    position: relative;
}

.menu-toggle {
    display: none;
    flex-direction: column;
    cursor: pointer;
}

.menu-toggle span {
    width: 25px;
    height: 3px;
    background-color: #000;
    margin: 5px 0;
}

/* Estilos para mobile */
@media (max-width: 768px) {
    .menu-toggle {
        display: flex;
    }

    .style-list {
        display: none;
        position: absolute;
        top: 60px;
        right: 0;
        left: 0;
        background-color: #fff;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 10px 0;
    }

    .style-list.active {
        display: flex; /* O menu só aparecerá quando a classe 'active' for aplicada */
    }

    .style-list li {
        margin: 10px 0;
    }
}
</style>